import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';

import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import {
  INPUT,
  MARKETING_OPT_EMAIL,
  MARKETING_OPT_IN,
  MARKETING_OPT_PHONE,
  MASKINPUT,
  TELEPHONE,
  TERMS_AND_CONDITIONS
} from 'common/constants/SharedConstants';
import { RESTRICTED_BAD_WORDS } from 'common/constants/restrictionWords';
import { checkRestrictedWords } from 'organisms/AccountPage/AU/accountPageUtils';

export const updateFormElementConfigData = (fields, id, cookiesSelected) => {
  return {
    ...fields,
    key: id,
    id: id,
    rules: {
      required: {
        value: fields?.required ?? false,
        message: `${translateWithI18Next(TRANSLATE_MAPPING_KEY?.ENTER_YOUR_Name)} ${fields?.label?.toLowerCase()}`,
      },
      pattern: {
        value: fields?.pattern ? RegExp(fields?.pattern) : null,
        message: `${translateWithI18Next(TRANSLATE_MAPPING_KEY?.INVALID_TEXT)} ${fields?.label?.toLowerCase()}`,
      },
      validate: textvalue =>
        fields?.dataType !== TELEPHONE && fields?.type === INPUT
          ? !checkRestrictedWords(RESTRICTED_BAD_WORDS, textvalue) ||
            `${translateWithI18Next(TRANSLATE_MAPPING_KEY?.INVALID_TEXT)} ${fields?.label?.toLowerCase()}`
          : true,
    },
    type: fields?.dataType === TELEPHONE ? MASKINPUT : fields?.type,
    phoneNumberMask: fields?.dataType === TELEPHONE ? fields?.phoneNumberMask : null,
    onChangeHandler: onFormElementChangeHandler,
    onBlurHandler: onFormElementChangeHandler,
    conditionalRender: false,
    htmlString: fields?.description ?? null,
    additionalDescription: fields?.optionalDescription ?? null,
    isMandatory: fields?.required ?? false,
    maxLength: fields?.maxLength ?? '',
    displayErrorMessage: fields?.name !== 'tnc',
    className: fields?.name === MARKETING_OPT_IN && !cookiesSelected ?'hide-cookies':'',
    errorClassName : fields?.name === TERMS_AND_CONDITIONS ? 'mandatory-checkbox-error' : ''
  };
};

export const prepareFormElmentConfig = (contentReducer, cookiesSelected) => {
 
  const dataUpdated = [];
  contentReducer?.guestContentData?.items?.[0]?.fields?.formField?.forEach(formElement => {
    const {
      fields,
      sys: { id },
    } = formElement;

    const configData = updateFormElementConfigData(fields, id, cookiesSelected);
    dataUpdated.push(configData);
    if (formElement?.fields?.name === MARKETING_OPT_IN) {
      formElement?.fields.values?.forEach(optParams =>
        dataUpdated.push({
          ...configData,
          additionalDescription: '',
          name: `marketingOpt${optParams}`,
          label: translateWithI18Next(optParams),
          className: 'ml-4',
          htmlString: '',
          type: 'checkbox',
          onChangeHandler: onFormElementChangeHandler,
          conditionalRender: true,
          rules: {
            required: {
              value: false,
              message: `${translateWithI18Next(
                TRANSLATE_MAPPING_KEY?.ENTER_YOUR_Name,
              )} ${formElement?.fields?.label?.toLowerCase()}`,
            },
            pattern: {
              value: formElement?.fields?.pattern ? RegExp(formElement?.fields?.pattern) : null,
              message: `${translateWithI18Next(
                TRANSLATE_MAPPING_KEY?.INVALID_TEXT,
              )} ${formElement?.fields?.label?.toLowerCase()}`,
            },
          },
        }),
      );
    }
  });
  return dataUpdated;
};

export const onFormElementChangeHandler = (formConfig, fieldConfig) => {
  const fieldValues = formConfig?.getValueFromElements?.();
  const fieldData = {};
  const tempCheckoutDetails = {};

  if (
    fieldConfig?.name === 'firstName' ||
    fieldConfig?.name === 'lastName' ||
    fieldConfig?.name === 'email' ||
    fieldConfig?.name === 'phoneNumber'
  ) {
    tempCheckoutDetails.cartDataCustomer = {
      ...formConfig?.checkoutDetails?.cartDataCustomer,
      [fieldConfig?.name]: fieldValues?.[fieldConfig?.name],
    };

    fieldData.value = fieldValues?.[fieldConfig?.name];
    fieldData.errorMessage = fieldConfig?.error?.message;
    fieldData.error = fieldConfig?.invalid;
  }

  switch (fieldConfig?.name) {
    case 'firstName':
      tempCheckoutDetails.userFirstName = fieldData;
      break;
    case 'lastName':
      tempCheckoutDetails.userLastName = fieldData;
      break;
    case 'email':
      tempCheckoutDetails.userEmail = fieldData;
      break;
    case 'phoneNumber':
      tempCheckoutDetails.userPhone = fieldData;
      break;
    case 'tnc':
      tempCheckoutDetails.termsPolicyCheckbox = fieldValues?.[fieldConfig?.name];
      break;
    case MARKETING_OPT_IN:
    case MARKETING_OPT_EMAIL:
    case MARKETING_OPT_PHONE:
      updateMarketingOptInValue(formConfig, fieldConfig, fieldValues, tempCheckoutDetails);
      break;
    // no default
  }
  formConfig?.updateCheckoutDetails({
    ...tempCheckoutDetails,
    isContactDetailValid: formConfig?.isFormValid,
    guestCheckOutFieldsValidated: formConfig?.isFormValid,
  });
};

export const updateMarketingOptInValue = (formConfig, fieldConfig, fieldValues, tempCheckoutDetails) => {
  let showAdditionalDescription = false;
  if (fieldConfig?.name === MARKETING_OPT_IN) {
    showAdditionalDescription = fieldValues?.marketingOptIn;
    formConfig?.setValueToFormElements(MARKETING_OPT_EMAIL, showAdditionalDescription);
    formConfig?.setValueToFormElements(MARKETING_OPT_PHONE, showAdditionalDescription);
  } else if (fieldConfig?.name === MARKETING_OPT_EMAIL || fieldConfig?.name === MARKETING_OPT_PHONE) {
    showAdditionalDescription = fieldValues?.marketingOptEmail || fieldValues?.marketingOptPhone;
    formConfig?.setValueToFormElements(MARKETING_OPT_IN, showAdditionalDescription);
  }

  const tempgFieldConfig = formConfig?.checkoutDetails?.guestCheckoutFormConfig?.fieldsConfig?.map(data => ({
    ...data,
    conditionalRender:
      data.name === MARKETING_OPT_EMAIL || data.name === MARKETING_OPT_PHONE
        ? !showAdditionalDescription
        : data?.conditionalRender,
    showAdditionalDescription,
  }));

  tempCheckoutDetails.guestCheckoutFormConfig = {
    ...formConfig?.checkoutDetails?.guestCheckoutFormConfig,
    fieldsConfig: tempgFieldConfig,
  };
  tempCheckoutDetails.marketingOptCheckbox = fieldValues?.marketingOptIn;
  tempCheckoutDetails.marketingOptInVal = {
    Email: fieldValues?.marketingOptEmail,
    Phone: fieldValues?.marketingOptPhone,
  };
  return tempCheckoutDetails;
};

export const resetGuestFormValue = updateCheckoutDetails => {
  updateCheckoutDetails({
    userEmail: { value: '', errorMessage: '', error: false },
    userFirstName: { value: '', errorMessage: '', error: false },
    userLastName: { value: '', errorMessage: '', error: false },
    userPhone: { value: '', errorMessage: '', error: false },
    termsPolicyCheckbox: false,
    isContactDetailValid: false,
    guestCheckOutFieldsValidated: false,
  });
};
